import React from 'react';
import {Link} from 'react-router';
import './PlaylistFooter.styl';
import {getDashboardPath} from 'components/StatsPage2.utils';

export default class PlaylistFooter extends React.PureComponent {
  render() {
    const {onCoachingTab, plan, sessionUser, fromPlanSubPage, backToMeetingLocation} = this.props;
    return (
      <div className="playlist-footer">
        {!onCoachingTab && plan && (
          <Link
            className="generic-link pointer"
            to={fromPlanSubPage ? backToMeetingLocation : getDashboardPath(sessionUser)}>
            {fromPlanSubPage ? 'Back to Meeting' : 'Back to Dashboard'}
          </Link>
        )}
      </div>
    );
  }
}
